/**
 * useAccountTabPrefs — the order the account page's tabs sit in, and which
 * ones the rep switched off.
 *
 * It reuses the `NavPrefs` CONTRACT rather than inventing a parallel one. The
 * helpers in `@techstack/core/navPrefs` are named for the sidebar but are in
 * fact generic key-ordering functions — `sortByNavPrefs(items, prefs, getKey)`
 * knows nothing about rails — and the two surfaces want identical semantics:
 * order plus hiding, unknown keys survive a round trip, preferences only ever
 * SUBTRACT. A second contract would be the same rules typed twice, and the
 * copy nobody updates is the one that drifts.
 *
 * It is a SEPARATE preference_type, though, not a second namespace inside
 * `nav_layout`: the sidebar and the account strip have colliding keys (both
 * have a "news"), and one blob would make hiding a page hide a tab.
 *
 * No migration — `user_preferences` takes any type, the same way the account
 * board landed (see ACCOUNT-BOARD.md).
 */

import { normalizeNavPrefs } from '@techstack/core';
import createPrefsStore from './createPrefsStore';

export const ACCOUNT_TAB_PREFS_TYPE = 'account_tab_layout';
const LOCAL_KEY = 'tekstak.accountTabs';

const store = createPrefsStore({
  type: ACCOUNT_TAB_PREFS_TYPE,
  localKey: LOCAL_KEY,
  normalize: normalizeNavPrefs,
});

export const hasAccountTabPrefsAccount = store.hasAccount;

export const useAccountTabPrefs = store.usePrefs;

export default useAccountTabPrefs;
